import './PrintBOV.scss';
import Component from './PrintBOV.js';
export default Component;
